const URL_BASE = 'https://partners-feedback.local';

function hasUrlScheme(url: string): boolean {
  return /^[a-z][a-z\d+\-.]*:/i.test(url);
}

export function withQueryParams(
  url: string,
  params: Record<string, string>,
): string {
  const parsed = new URL(url, URL_BASE);

  Object.entries(params).forEach(([key, value]) => {
    parsed.searchParams.set(key, value);
  });

  if (hasUrlScheme(url)) {
    return parsed.href;
  }

  if (url.startsWith('//')) {
    return `//${parsed.host}${parsed.pathname}${parsed.search}${parsed.hash}`;
  }

  const relativeUrl = `${parsed.pathname}${parsed.search}${parsed.hash}`;

  return url.startsWith('/') ? relativeUrl : relativeUrl.replace(/^\//, '');
}
